// extracted by mini-css-extract-plugin
export default {"likeButton":"LV-z","unLikedButton":"MV-z","likedButton":"NV-z"};